module.exports = {
	"Play": "Wiedergabe",
	"Pause": "Pause",
	"Current Time": "Aktueller Zeitpunkt",
	"Duration Time": "Dauer",
	"Remaining Time": "Verbleibende Zeit",
	"Stream Type": "Streamtyp",
	"LIVE": "LIVE",
	"Loaded": "Geladen",
	"Progress": "Status",
	"Fullscreen": "Vollbild",
	"Non-Fullscreen": "Kein Vollbild",
	"Mute": "Ton aus",
	"Unmute": "Ton ein",
	"Playback Rate": "Wiedergabegeschwindigkeit",
	"Subtitles": "Untertitel",
	"subtitles off": "Untertitel aus",
	"Captions": "Untertitel",
	"captions off": "Untertitel aus",
	"Chapters": "Kapitel",
	"You aborted the media playback": "Sie haben die Videowiedergabe abgebrochen.",
	"A network error caused the media download to fail part-way.": "Der Videodownload ist aufgrund eines Netzwerkfehlers fehlgeschlagen.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Das Video konnte nicht geladen werden, da entweder ein Server- oder Netzwerkfehler auftrat oder das Format nicht unterstützt wird.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Die Videowiedergabe wurde entweder wegen eines Problems mit einem beschädigten Video oder wegen verwendeten Funktionen, die vom Browser nicht unterstützt werden, abgebrochen.",
	"No compatible source was found for this media.": "Für dieses Video wurde keine kompatible Quelle gefunden.",
	"Play Video": "Video abspielen",
	"Close": "Schließen",
	"Modal Window": "Modales Fenster",
	"This is a modal window": "Dies ist ein modales Fenster",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Durch Drücken der Esc-Taste bzw. Betätigung der Schaltfläche \"Schließen\" wird dieses modale Fenster geschlossen.",
	", opens captions settings dialog": ", öffnet Einstellungen für Untertitel",
	", opens subtitles settings dialog": ", öffnet Einstellungen für Untertitel",
	", selected": ", ausgewählt",
	"Close Modal Dialog": "Modales Fenster schließen",
	"Descriptions": "Beschreibungen",
	"descriptions off": "Beschreibungen aus",
	"The media is encrypted and we do not have the keys to decrypt it.": "Die Entschlüsselungsschlüssel für den verschlüsselten Medieninhalt sind nicht verfügbar.",
	", opens descriptions settings dialog": ", öffnet Einstellungen für Beschreibungen",
	"Audio Track": "Tonspur"
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/de.json
// module id = 583
// module chunks = 1